import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
export function WhoIsForSection() {
  const isFor = ['Latinos en USA que necesitan subir sus ingresos de inmediato.', 'Personas con inglés limitado que temen al examen escrito.', 'Trabajadores que no tienen meses para estudiar y necesitan la licencia en una semana.', 'Cualquier persona que quiera entrar a la industria del transporte con el pie derecho.'];
  const notFor = ['Personas que ya son mecánicos certificados o bilingües avanzados.', 'Quienes buscan una carrera académica larga en lugar de un oficio práctico.', 'Aquellos que no están dispuestos a dedicar al menos 45 minutos al día para estudiar.'];
  return <section className="py-20 bg-slate-800 px-4 sm:px-6 lg:px-8 border-y border-slate-700" data-id="element-218">
      <div className="max-w-6xl mx-auto" data-id="element-219">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-220">
          {/* Para Quién Es */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-900/50 rounded-3xl p-8 md:p-10 border border-emerald-500/20 relative overflow-hidden" data-id="element-221">
            <div className="absolute top-0 left-0 w-full h-2 bg-emerald-500" data-id="element-222"></div>
            <h3 className="text-3xl font-oswald font-bold text-white mb-8 uppercase flex items-center gap-3" data-id="element-223">
              <CheckCircle className="text-emerald-500 w-8 h-8" data-id="element-224" />
              Para Quién ES
            </h3>
            <ul className="space-y-6" data-id="element-225">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-226">
                  <CheckCircle className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-227" />
                  <span className="text-slate-300 text-lg" data-id="element-228">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Para Quién NO Es */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-900/50 rounded-3xl p-8 md:p-10 border border-red-500/20 relative overflow-hidden" data-id="element-229">
            <div className="absolute top-0 left-0 w-full h-2 bg-red-500" data-id="element-230"></div>
            <h3 className="text-3xl font-oswald font-bold text-white mb-8 uppercase flex items-center gap-3" data-id="element-231">
              <XCircle className="text-red-500 w-8 h-8" data-id="element-232" />
              Para Quién NO ES
            </h3>
            <ul className="space-y-6" data-id="element-233">
              {notFor.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-234">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-235" />
                  <span className="text-slate-400 text-lg" data-id="element-236">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}